import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { BadgeCheckIcon } from 'lucide-react';
import { useStore } from '../contexts/StoreContext';
import { VehicleCard } from '../components/VehicleCard';
import { BrandCover } from '../components/brand/BrandCover';
import { getEffectiveOffer, isOfferPublishable } from '../utils/finance';
import { formatDate } from '../utils/format';
export function BrandDetail() {
  const {
    slug
  } = useParams();
  const {
    brands,
    vehicles
  } = useStore();
  const brand = brands.find(b => b.slug === slug);
  if (!brand) {
    return <div className="container-x py-24 text-center" data-id="element-1154" data-mp="2unxet5ubrni4">
        <h1 className="font-display text-2xl font-bold" data-id="element-1155" data-mp="2upi86s4wl0ee">Marca no encontrada</h1>
        <Link to="/marcas" className="btn btn-primary mt-6" data-id="element-1156" data-mp="2pwp3235ivq1s">Ver marcas</Link>
      </div>;
  }
  const list = vehicles.filter(v => v.published && v.brandId === brand.id);
  const models = Array.from(new Set(list.map(v => v.model)));
  const promos = list.map(v => ({
    v,
    ctx: getEffectiveOffer(v, brands)
  })).filter(x => x.ctx && x.ctx.source === 'unidad' && x.ctx.offer.promo && isOfferPublishable(x.ctx.offer));
  const brandVerified = isOfferPublishable(brand.defaultOffer);
  return <div data-id="element-1157" data-mp="352in0q27jvmy">
      <BrandCover key={brand.slug} slug={brand.slug} name={brand.name} tagline={brand.tagline} modelsCount={models.length} versionsCount={list.length} data-id="element-1158" data-mp="352sc8bffhyrl" />

      <section className="container-x py-10" aria-labelledby="promo-title" data-id="element-1159" data-mp="2cduz0mq2qs5p">
        <h2 id="promo-title" className="font-display text-xl font-bold" data-id="element-1160" data-mp="2hcekyn4o43y2">Promociones vigentes</h2>
        {promos.length === 0 && !brandVerified ? <p className="mt-2 text-sm text-mist" data-id="element-1161" data-mp="2ld83t2396sk3">No hay promociones con condiciones verificadas en este momento. Consultá con un asesor por novedades.</p> : <ul className="mt-4 divide-y divide-line border-y border-line" data-id="element-1162" data-mp="oaebi5k0898">
            {brandVerified && <li className="flex flex-col gap-1 py-4 sm:flex-row sm:items-center sm:justify-between" data-id="element-1163" data-mp="5m2fz3w038qm">
                <span className="flex items-center gap-2 text-sm" data-id="element-1164" data-mp="21oysyn7cabnc"><BadgeCheckIcon className="h-4 w-4 text-ok" aria-hidden data-id="element-1165" data-mp="21rus2euxb6dd" />Condiciones generales verificadas para toda la marca</span>
                <span className="text-xs text-mist" data-id="element-1166" data-mp="2bopn2nrzmomw">Vigentes hasta {formatDate(brand.defaultOffer.validUntil)}</span>
              </li>}
            {promos.map(({
          v,
          ctx
        }) => <li key={v.id} className="flex flex-col gap-2 py-4 sm:flex-row sm:items-center sm:justify-between" data-id="element-1167" data-mp="1iz8wzwrubjtu">
                <div data-id="element-1168" data-mp="1e176wrvzyk8v">
                  <p className="font-semibold" data-id="element-1169" data-mp="1e1qrkgd17mql">{v.model} {v.version}</p>
                  <p className="text-sm text-neon" data-id="element-1170" data-mp="1splibr7hbh11">{ctx?.offer.promo}</p>
                </div>
                <div className="flex items-center gap-4" data-id="element-1171" data-mp="1ny3fsypt58dy">
                  <span className="text-xs text-mist" data-id="element-1172" data-mp="1nwimfcf8bvho">Hasta {ctx && formatDate(ctx.offer.validUntil)}</span>
                  <Link to={`/simulador?v=${v.id}`} className="btn btn-ghost h-9" data-id="element-1173" data-mp="106obx1iduj0l">Simular</Link>
                </div>
              </li>)}
          </ul>}
      </section>

      <section className="container-x pb-16" aria-labelledby="models-title" data-id="element-1174" data-mp="36v6ss9fy2m1u">
        <h2 id="models-title" className="font-display text-xl font-bold" data-id="element-1175" data-mp="3bpkrakpwl9aq">Modelos</h2>
        {models.map(m => <div key={m} className="mt-6" data-id="element-1176" data-mp="2xuicf832w9ls">
            <h3 className="mb-3 text-sm font-semibold text-mist" data-id="element-1177" data-mp="31xoqv30ch73c">{m}</h3>
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-1178" data-mp="31vu3li1lp2w3">
              {list.filter(v => v.model === m).map(v => <VehicleCard key={v.id} vehicle={v} data-id="element-1179" data-mp="3umlx27ra7dfq" />)}
            </div>
          </div>)}
        {list.length === 0 && <p className="mt-3 text-sm text-mist" data-id="element-1180" data-mp="3gnvysosq77ps">No hay unidades publicadas para esta marca.</p>}
      </section>
    </div>;
}